import styled from 'styled-components';
import { rgba } from '../../utils/polished';
import useTheme from '../../utils/useTheme';

const BackgroundContainer = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
`;

const Bar = styled.div`
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${rgba(theme.vars.newColor.blue4, 0.6)} 0%, ${rgba(theme.vars.newColor.blue4, 0)} 100%)`};
  height: 57.3rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 100vw;
`;

const CircleWrapper = styled.div`
  max-width: 192rem;
  position: relative;
  width: 100%;
`;

type CircleSize = 'small' | 'medium' | 'large' | 'extra-large';

const Circle = styled.div<{
  background: string;
  top?: number;
  left?: number;
  size?: CircleSize;
}>`
  background-color: ${({ background }) => background};
  border-radius: 50%;
  box-shadow: 0px 12px 34px ${({ theme }) => rgba(theme.vars.newColor.blue2, 0.23)};
  height: ${({ size }) => getSize(size)};
  left: ${({ left }) => left}%;
  opacity: 0.2;
  position: absolute;
  top: ${({ top }) => top}%;
  width: ${({ size }) => getSize(size)};
`;

const getSize = (size: CircleSize = 'medium') => {
  switch (size) {
    case 'extra-large':
      return '10.7rem';
    case 'large':
      return '7rem';
    case 'medium':
      return '4.8rem';
    case 'small':
      return '2.3rem';
  }
};

export const BackgroundGradient = () => {
  const theme = useTheme();

  return (
    <BackgroundContainer>
      <Bar />

      <CircleWrapper>
        <Circle top={9} left={17} background={theme.vars.newColor.gold3} size="small" />
        <Circle top={25} left={19} background={theme.vars.newColor.purple2} size="large" />
        <Circle top={69} left={14} background={theme.vars.newColor.green3} size="medium" />
        <Circle top={96} left={17} background={theme.vars.newColor.blue3} size="extra-large" />

        <Circle top={-4} left={47} background={theme.vars.newColor.purple2} size="large" />

        <Circle top={8} left={92} background={theme.vars.newColor.blue3} size="extra-large" />
        <Circle top={29} left={86} background={theme.vars.newColor.green3} size="medium" />
        <Circle top={40} left={82} background={theme.vars.newColor.gold3} size="small" />
        <Circle top={78} left={75} background={theme.vars.newColor.green3} size="medium" />
      </CircleWrapper>
    </BackgroundContainer>
  );
};

export default BackgroundGradient;
